module.exports = __webpack_public_path__ + "media/images/icon__point--gained@2x-0f16cb4c97e261b96be8d4a44df5a533.png";